<template>
  <div class="wrokGroup-wrap page-padding">
    <div class="flex-row flex-auto"
         style="overflow: hidden;">
      <!-- 工作组左侧树 -->
      <div class="section-mian_left"
           style="width: 300px;">
        <div class="area-search">
          <el-input placeholder="请输入搜索关键字"
                    prefix-icon="el-icon-search"
                    v-model="searchString"
                    clearable>
          </el-input>
        </div>
        <el-scrollbar class="flex-auto"
                      style="overflow: hidden; margin: 0 10px;">
          <el-tree v-if="showTree"
                   ref="tree"
                   class="tree-content"
                   :data="treeData"
                   :expand-on-click-node="false"
                   node-key="id"
                   :default-expanded-keys="expandedKeys"
                   render-after-expand
                   :load="asyncLoadNode"
                   :lazy="lazyLoad"
                   :props="treeProps"
                   :highlight-current="true"
                   :filter-node-method="filterNode"
                   @node-click="nodeClick">
            <span class="custom-tree-node"
                  slot-scope="{ node, data }">
              <span>{{ node.label }}</span>
              <span v-if="workGroupCode === data.id">
                <div class="area-operator"
                     @click="addClick">
                  <el-button type="text"
                   v-auth="'/workshop:add'"
                             class="el-icon-plus"
                             size="mini"
                             @click="() => appendArea(data)"></el-button>
                  <el-button v-if="data.parentCode !== '-1'"
                             type="text"
                              v-auth="'/workshop:delete'"
                             class="el-icon-delete-solid"
                             size="mini"
                             @click="() => removeArea(node, data)"></el-button>
                  <el-button type="text"
                   v-auth="'/workshop:update'"
                             class="el-icon-edit-outline"
                             size="mini"
                             @click="() => editArea(node, data)"></el-button>
                </div>
              </span>
            </span>
          </el-tree>
        </el-scrollbar>
      </div>
      <div class="flex-auto flex-valign"
           style="overflow: hidden">
        <ioc-table ref="crud"
                   :data="tableData"
                   :option="tableOption"
                   :page="{}"
                   @size-change="changeSize"
                   @current-change="currentChange"
                   @selection-change="handleSelectionChange"
                   @search-change="searchList"
                   @search-reset="resetQuery">
          <!-- menuLeft -->
          <template slot="menuLeft">
            <div>
              <el-button type="primary"
              v-auth="'/workshop:add'"
                         class="iss-operation-button"
                         icon="el-icon-plus"
                         @click="addSecurityStaff">
                新增
              </el-button>
              <el-button type="primary"
                         class="iss-operation-button"
                         icon="el-icon-delete"
                          v-auth="'/workshop:delete'"
                         @click="deleteSecurity">
                删除
              </el-button>
            </div>
          </template>
          <!-- <template slot="accountListForm">
            <IocTransfer :value="accountList"
                         :data="transferList"
                         type="step"
                         :filterable="false"
                         :props="propStep"
                         :titles="['保卫账户列表', '已选保卫账户']"
                         @changeData="changeData">
            </IocTransfer>
            <el-transfer v-model="linkAssetsModel"
                         :titles="['保卫账户列表', '已选保卫人员']"
                         :data="linkAssetsData"
                         @change="rightChange"
                         @right-check-change="rightCheckChange"
                         :props="{
          key: 'fireassetName',
          label: 'fireassetName',
        }">
            </el-transfer>
          </template> -->
          <template slot="img"
                    slot-scope="scope">
            <img :src="getImgPath(scope.row.fileCode)"
                 @click="showViewer(getImgPath(scope.row.fileCode), $event)"
                 onerror="this.src='/images/theme/newDark/default.png'"
                 style="height: 25px; width: 50px" />
          </template>
        </ioc-table>
      </div>
    </div>

    <viewer @inited="inited"
            :images="viewerPhotos"
            class="viewer"
            ref="viewer">
      <img v-for="src in viewerPhotos"
           :src="src"
           :key="src" />
    </viewer>
    <!-- 新增保卫工作组弹窗 -->
    <add-security ref="securityForm"
                  :state="state"
                  :treeInfo="clickTreeInfo"
                  @refresh="refreshPage"></add-security>

    <!-- <el-dialog title="人员选择"
               :visible.sync="staffDialog"
               width="860px"
               class="choose-account">
      <ioc-table ref="securityTable"
                 :data="securityData"
                 :option="accountOption"
                 :page="securitytPage"
                 @selection-change="securitySelectionChange"
                 @size-change="securityChangeSize"
                 @current-change="securityChange"
                 @search-change="searchSecurity"
                 @search-reset="securityReset">
      </ioc-table>
      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   @click="addSecurityt">确认</el-button>
      </span>
    </el-dialog> -->

    <!-- 新增保卫人员 -->
    <person-transfer ref="transfer"
                     :workGroupCode="workGroupCode"
                     @refreshData="refresh"></person-transfer>
  </div>
</template>
<script>
// 工具库
import utils from '$utils'
import { Dic, Bus, Validate, Dates, } from "$utils";
import tableOption from "../options/table";
import accountOption from "../options/accountOptions";
import { api } from "../api";
import addSecurity from "../components/addSecurity"
import IocTransfer from '@src/components/common/ioc-component/ioc-transfer'
import personTransfer from '../components/person-transfer'
const trim = (str) => {
  return str.replace(/^\s+|\s+$/g, "");
};
export default {
  name: "perimeter",
  components: {
    addSecurity,
    // IocTransfer,
    personTransfer
  },
  data () {
    return {
      viewerInstance: null,
      viewerPhotos: [],
      tableOption: tableOption(true, true),
      tableData: [],
      page: {
        pageNum: 1,
        pageSize: utils.Cache.get('CURRENT_PAGESIZE') || 10,
        total: 0,
      },
      searchParams: {},

      state: 1, // 1: 新增 2：修改
      workGroupCode: "", //工作组code
      staffDialog: false,
      securityData: [],
      accountOption: accountOption(),
      securitytPage: {
        pageNum: 1,
        total: 10,
        pageSize: utils.Cache.get('CURRENT_PAGESIZE') || 10,
      },
      securitytSearch: {},
      securityList: [],
      treeData: Object.freeze([]),
      // 展开的节点id
      expandedKeys: [],
      // 缓存全量树结构
      cacheTree: [],
      showTree: true,
      lazyLoad: false,
      treeProps: {
        children: 'children',
        label: 'name',
        isLeaf: 'isLeaf',
      },
      searchString: '',
      // 根节点code
      rootCode: '',
      // 传递给弹框的信息
      clickTreeInfo: {},
      accountList: [],
      transferList: [],
      accountChecked: [],
      propStep: {
        label: 'nickName',
        key: 'accountNumber',
      },
      deleteSecurityList: []
    };
  },
  watch: {
    searchString (val) {
      this.$refs.tree.filter(val);
    }
  },
  created () {
    this.accountOption.selection = true;
  },
  mounted () {
    this.getWorkGroupTree();
    // this.getAccountList();
  },
  methods: {
    inited (viewer) {
      this.viewerInstance = viewer;
    },
    showViewer (src, e) {
      this.viewerPhotos = [e.target.src.indexOf('default/default.png') == -1 ? e.target.src + "&sourceFileFlag=1" : e.target.src];
      //this.viewerPhotos = [e.target.src];
      this.viewerInstance.show();
    },
    getImgPath (item) {
      return item ? Bus.imgPath(item) : "";
    },
    getAccountList () {
      const param = {
        accountType: 1
      }
      this.$fetch(api.queryAccouts, param).then((response) => {
        if (response.success) {
          this.transferList = response.returnObj
        }
      })
    },
    changeData (data) {
      this.accountChecked = data;
    },

    //获取工作组树列表
    getWorkGroupTree () {
      const self = this
      this.$fetch(api.querySecurityWorkGroup, {}).then((response) => {
        const result = self.menusDataPro(response.returnObj)
        self.cacheTree = result;
        self.treeData = Object.freeze(result);
        self.rootCode = self.treeData[0].id;
        self.workGroupCode = self.rootCode
        self.expandedKeys = [self.treeData[0].id];
        // 默认高亮根节点
        this.$nextTick(function () {
          this.$refs.tree.setCurrentKey(self.rootCode);
          this.getList(self.workGroupCode);
        })
      })
    },
    //递归树结构
    menusDataPro (data) {
      const self = this
      const result = []
      if (data !== null) {
        data.forEach(function (item) {
          const entity = {}
          entity.id = item.securityWorkGroupCode
          entity.name = item.securityWorkGroupName
          entity.appointmentCarNotifyFlag = item.appointmentCarNotifyFlag
          entity.appointmentNoCarNotifyFlag = item.appointmentNoCarNotifyFlag
          entity.leaderCode = item.securityWorkGroupLeader
          entity.leaderName = item.leaderName
          entity.parentCode = item.parentCode
          entity.areaDevGroupCodeList = item.areaDevGroupCodeList
          entity.isLeaf = !item.hasLeaf || !item.securityWorkGroupChildren
          if (item.securityWorkGroupChildren) {
            entity.children = self.menusDataPro(item.securityWorkGroupChildren)
          }
          result.push(entity)
        })
        return result
      }
    },
    showOwnerList (list) {
      return list.map((item) => item.personnelName).join(',')
    },
    // 异步加载树子节点 加载子树数据的方法，仅当 lazy 属性为true 时生效
    asyncLoadNode (node, resolve) {
      if (node.data && node.data.children) {
        return resolve(node.data.children)
      } else {
        return resolve([])
      }
    },
    filterNode (value, data) {
      if (!value) {
        return true
      }
      return data.name.indexOf(value) !== -1
    },
    // 单击节点时
    nodeClick (data) {
      // console.log('-----节点nodeClick点击----:', data)
      this.workGroupCode = data.id;
      let parentNode = this.$refs.tree.getNode(data.parentCode)
      // console.log('-----被点击的节点的父节点信息-----:', parentNode)
      this.getList(this.workGroupCode)
    },
    addClick (event) {
      event.stopPropagation()
    },
    appendArea (evt) {
      // console.log('----新增工作组----:', evt)
      this.state = 1;
      this.clickTreeInfo = evt
      this.$refs.securityForm.open();
    },
    removeArea (node, data) {
      // console.log('----删除node----', node);
      // console.log('----删除data----', data);
      let idsArr = [];
      idsArr.push(data.id)
      if (data.children && data.children.length !== 0) {
        data.children.forEach((item) => {
          idsArr.push(item.id)
        })
      }
      this.$confirm("您确定删除该工作组及下属工作组么?", "确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          securityWorkGroupCodes: idsArr,
        };
        // console.log('---删除ids----', params);
        this.$fetch(api.deleteSecurityWorkGroup, params).then((response) => {
          if (!response.success) {
            this.$message.error(response.msgContent);
            return;
          } else {
            this.$message.success("删除成功");
            this.refreshPage()
          }
        });
      });
    },
    editArea (node, data) {
      // console.log('----修改node----', node);
      // console.log('----修改data----', data);
      this.clickTreeInfo = data;
      this.state = 2;
      this.$nextTick(() => {
        this.$refs.securityForm.open();
      })
    },

    refreshPage () {
      this.getWorkGroupTree();
      this.getList(this.workGroupCode);
    },
    refresh () {
      this.getList(this.workGroupCode);
    },


    // 保卫人员新增按钮
    addSecurityStaff () {
      // this.staffDialog = true;
      // this.accountList = [];
      this.$refs.transfer.open()
    },
    // 保卫人员删除按钮
    deleteSecurity () {
      if (this.deleteSecurityList.length === 0) {
        this.$message.warning("请选择需要删除的保卫人员")
      } else {
        this.$confirm("您确定删除选中的保卫人员么?", "确认", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.$fetch(api.deleteSecurityInfo, this.deleteSecurityList).then(res => {
            if (res.success) {
              this.$message.success('删除保卫人员成功');
              this.refreshPage();
            } else {
              this.$message.error(res.msgContent);
            }
          });
        });
      }
    },
    handleSelectionChange (data) {
      this.deleteSecurityList = data.map(item => {
        return {
          accountNumber: item.accountNumber,
          securityWorkGroupCode: item.securityWorkGroupCode
        }
      });
    },
    getList (code) {
      const params = {};
      params.nickName = this.searchParams.nickName;
      params.securityWorkGroupCode = code;
      params.phone = this.searchParams.phone;
      this.$fetch(api.getSecurityInfoList, params).then((response) => {
        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        }
        this.tableData = response.returnObj
          ? Object.freeze([...response.returnObj])
          : [];
        this.$refs.crud.selectClear();
      });
    },
    // 重置按钮
    resetQuery () {
      this.getList(this.workGroupCode);
    },
    searchList (param) {
      this.searchParams = Object.assign(param);
      this.getList(this.workGroupCode);
    },
    // 保卫人员
    // getAccountList () {
    //   const params = {};
    //   params.accountType = 1;
    //   params.nickName = this.securitytSearch.nickName;
    //   params.accountNumber = this.securitytSearch.accountNumber;
    //   params.pageNo = this.securitytPage.pageNum;
    //   params.pageSize = this.securitytPage.pageSize;
    //   this.$fetch(api.queryAccouts, params).then((response) => {
    //     if (!response.success) {
    //       this.$message.error(response.msgContent);
    //       return;
    //     }
    //     this.securityData = response.returnObj
    //       ? Object.freeze([...response.returnObj.list])
    //       : [];
    //     this.securitytPage.total = response.returnObj
    //       ? response.returnObj.total
    //       : 0;
    //   });
    // },
    addSecurityt () {

    },
    securitySelectionChange (items) {
      this.securityList = items.map((item) => {
        return {
          securityCode: item.id,
          securityName: item.nickName,
        }
      })
    },
    // 修改每页数据数量
    changeSize (val) {
      this.page.pageNum = 1;
      this.page.pageSize = val;
      //调用列表接口
      this.getList();
    },
    // 点击上一页下一页按钮
    currentChange (val) {
      this.page.pageNum = val;
      //调用列表接口
      this.getList();
    },
    securityChangeSize (val) {
      this.securitytPage.pageNum = 1;
      this.securitytPage.pageSize = val;
      this.getAccountList();
    },
    securityChange (val) {
      this.securitytPage.pageNum = val;
      this.getAccountList();
    },
    searchSecurity (param) {
      this.securitytSearch = Object.assign(param);
      this.securitytPage.pageNum = 1;
      this.getAccountList();
    },
    securityReset () {
      this.getAccountList();
    },

  },
};
</script>
<style lang="scss">
@import "~@src/common/assets/style/mixin";
.wrokGroup-wrap {
  width: 100%;
  height: calc(100% - 12px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: relative;
  margin-top: 12px!important;

  .ioc-table {
    padding-top: 0;
  }
  .section-mian_left {
    margin-right: 10px;
    display: flex;
    flex-direction: column;
    .area-search {
      display: flex;
      margin-bottom: 20px;
      height: 28px;
      .el-input {
        margin-right: 10px;
        width: 100%;
      }
    }
    .tree-content {
      width: fit-content;
      min-width: 100%;
      .el-tree-node__label {
        display: inline-block;
        max-width: 80%;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
      .el-tree-node__content {
        height: 40px;
        line-height: 40px;
        &:hover {
          background: rgb(45, 73, 118);
        }
        .custom-tree-node {
          width: 100%;
          height: 40px;
          line-height: 40px;
          span {
            display: inline-block;
            width: 130px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }

          .area-operator {
            display: inline-block;
            margin-left: 10px;
          }
        }
        &:before {
          margin-top: -26px !important;
        }
      }
    }
  }
  .el-transfer-panel {
    @include set_theme_color(background-color,page-bg-color);

    &__header {
      @include set_theme_color(background-color, blur-color);
    }
    .el-checkbox__label {
      color: #fff !important;
    }
  }
}
</style>
